import { useEffect, useRef, useState } from 'react'
import HalfCurveBottom from '../Icons/HalfCurveBottom'
import PlayIcon from '../Icons/PlayIcon'
import PauseIcon from '../Icons/PauseIcon'

const HeroSection = ({ data }) => {
  const videoRef = useRef(null)
  const hideTimer = useRef(null)

  const [isPlaying, setIsPlaying] = useState(true)
  const [isMuted, setIsMuted] = useState(true)
  const [showControls, setShowControls] = useState(true)

  const videoUrl = data?.video?.videoUrl

  useEffect(() => {
    const video = videoRef.current
    if (!video || !videoUrl) return

    const attemptPlay = () => {
      video
        .play()
        .then(() => setIsPlaying(true))
        .catch(() => setIsPlaying(false))
    }

    attemptPlay()
    video.addEventListener('loadeddata', attemptPlay)

    return () => {
      video.removeEventListener('loadeddata', attemptPlay)
    }
  }, [videoUrl])

  // Auto hide controls
  const startHideTimer = () => {
    clearTimeout(hideTimer.current)
    hideTimer.current = setTimeout(() => {
      setShowControls(false)
    }, 1000)
  }

  const showControlsTemporarily = () => {
    setShowControls(true)
    startHideTimer()
  }

  useEffect(() => {
    startHideTimer()
    return () => clearTimeout(hideTimer.current)
  }, [])

  const handlePlayPause = () => {
    const video = videoRef.current
    if (!video) return

    if (video.paused) {
      video.play()
      setIsPlaying(true)
    } else {
      video.pause()
      setIsPlaying(false)
    }

    showControlsTemporarily()
  }

  const toggleMute = () => {
    const video = videoRef.current
    if (!video) return

    video.muted = !video.muted
    setIsMuted(video.muted)

    showControlsTemporarily()
  }

  if (!videoUrl) return null

  return (
    <section
      className="px-4 relative"
      onMouseMove={showControlsTemporarily}
      onTouchStart={showControlsTemporarily}
      onClick={showControlsTemporarily}
    >
      <div className="overflow-hidden -mt-0.5 -mx-4 relative">
        <video
          ref={videoRef}
          src={videoUrl}
          autoPlay
          loop
          playsInline
          muted
          preload="auto"
          className="w-full h-full object-cover aspect-video"
        />

        {/* Play / Pause */}
        {showControls && (
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-opacity">
            {isPlaying ? (
              <PauseIcon height={50} width={50} onClick={handlePlayPause} />
            ) : (
              <PlayIcon height={50} width={50} onClick={handlePlayPause} />
            )}
          </div>
        )}

        {/* Mute / Unmute */}
        <button
          onClick={toggleMute}
          className="absolute z-10 bottom-4 right-4 bg-black/40 text-white text-xs px-3 py-2 rounded-full backdrop-blur"
        >
          {isMuted ? 'Unmute 🔊' : 'Mute 🔇'}
        </button>
      </div>

      <HalfCurveBottom className="w-screen -mx-4 relative -mt-4" />
    </section>
  )
}

export default HeroSection
